import axios from 'axios';
import { TaskAttachment } from '../types/Task';

const BASE_URL = '/api/attachments';

export const attachmentService = {
  uploadAttachment: async (taskId: string, file: File, notes?: string) => {
    const formData = new FormData();
    formData.append('file', file);
    if (notes) formData.append('notes', notes);
    
    const response = await axios.post(`${BASE_URL}/task/${taskId}/attachment`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  getTaskAttachments: async (taskId: string): Promise<TaskAttachment[]> => {
    const response = await axios.get(`${BASE_URL}/task/${taskId}/attachments`);
    return response.data;
  },

  deleteAttachment: async (attachmentId: string) => {
    try {
      const response = await axios.delete(`${BASE_URL}/attachment/${attachmentId}`);
      if (response.status !== 200) {
        throw new Error('Failed to delete attachment');
      }
      return response.data;
    } catch (error) {
      console.error('Error deleting attachment:', error);
      throw error;
    }
  },

  downloadAttachment: async (attachmentId: string) => {
    try {
      const response = await axios.get(`${BASE_URL}/download/${attachmentId}`, {
        responseType: 'blob'
      });
      
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      
      // Get filename from Content-Disposition header or use a default
      const contentDisposition = response.headers['content-disposition'];
      const fileName = contentDisposition
        ? contentDisposition.split('filename=')[1].replace(/"/g, '')
        : 'download';
        
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
      throw error;
    }
  }
}; 